import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Spinner,
  Input,
} from "@chakra-ui/react";
import useAxios from "axios-hooks";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useRecoilState, useSetRecoilState } from "recoil";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { toastState } from "atoms/toastState";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import Card from "components/card/Card";
import logger from "infra/logger";
import { createUserProfileDrawerState } from "atoms/createUserProfileDrawerState";
import { useNavigate } from "react-router-dom";

const CreateUserProfileDrawer = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const setToast = useSetRecoilState(toastState);
  const [drawerState, setDrawerState] = useRecoilState(
    createUserProfileDrawerState
  );
  const navigate = useNavigate();
  const validationSchema = yup.object().shape({
    Name: yup.string().min(3).required("Name is required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    register,
    setValue,
    getValues,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const [{ data, loading: createLoading, error }, createUserProfile] = useAxios(
    { method: "POST", url: `/api/userprofiles/create` },
    { manual: true }
  );

  const createHandler = async () => {
    setIsLoading(true);
    const formValues = getValues();
    let data = {};

    if (formValues.Name.trim() !== "") {
      data["Name"] = formValues.Name.trim();
    }

    logger.log(formValues);
    logger.log(data);

    if (Object.keys(data).length === 1) {
      try {
        const response = await createUserProfile({ data: data });

        setToast({
          isOpen: true,
          title: "Group Created successfully",
          status: "success",
        });
        props.update();
        closeHandler();
        navigate(`/admin/userprofiles/view/${response.data.data.Id}`);
      } catch (error) {
        const err = error?.response?.data?.error;
        logger.log(error);
        setToast({
          isOpen: true,
          title: "Error occurred when creating Group",
          description: err ? err : null,
          status: "error",
        });
      }
    } else {
      setToast({
        isOpen: true,
        title: "Enter the name to create Group",
        status: "warning",
        position: "top",
      });
    }
    setIsLoading(false);
  };

  const closeHandler = () => {
    setDrawerState({ isOpen: false });
  };

  return (
    <Drawer
      isOpen={drawerState?.isOpen}
      placement="right"
      onClose={closeHandler}
      size="md"
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Create a new Group</DrawerHeader>

        <DrawerBody>
          {!createLoading ? (
            <>
              <Card>
                <form>
                  <Flex mb="20px" alignItems="center">
                    <Controller
                      name="Name"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <FormControl
                          isRequired
                          flexDirection="row"
                          isInvalid={errors.Name}
                        >
                          <FormLabel fontSize={20}>Group Name</FormLabel>
                          <Input
                            {...field}
                            focusBorderColor="brand.500"
                            fontSize="sm"
                            placeholder="Enter group name"
                            width="400px"
                            height="50px"
                            type="text"
                            isRequired
                          />
                          <FormErrorMessage mb={"20px"}>
                            {errors.Name && errors.Name.message}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    />
                  </Flex>

                  <Flex gap={3} mt={4}>
                    <Button variant="outline" flex={1} onClick={closeHandler}>
                      Cancel
                    </Button>
                    <Button
                      flex={1}
                      bg="brand.500"
                      color="white"
                      colorScheme="brand"
                      onClick={handleSubmit(createHandler)}
                      isLoading={isLoading}
                      loadingText="Creating"
                      spinner={<Spinner size="md" />}
                      disabled={isLoading}
                    >
                      Create
                    </Button>
                  </Flex>
                </form>
              </Card>
            </>
          ) : (
            <LoadingSpinner />
          )}
        </DrawerBody>

        <DrawerFooter></DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default CreateUserProfileDrawer;
